<template>
    <div class="container container-table">
        <div class="row">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-solid box-info">
                        <div>
                            <div class="box-body">
                                <div class="row">
                                    <div style="width:224px;margin:auto;">
                                        <img src="../../src/assets/img/account/developer.png" class="center-block1">
                                    </div>
                                    <div style="test_all">
                                    <div class="text-center col-md-4 col-sm-offset-4 container">
                                        <form class="ui form loginForm container">
                                            <div class="mail-02"><img class="mail-02_image" src="../../src/assets/img/account/gra-account-mail.jpg" alt=""></div>
                                             <div class="Youre-almost-ready">
                                                 <!-- <p>You&apos;re almost ready to go!</p> -->
                                                 <p>{{ $t('account.common.AccountAuthenticationEmail.content.creat') }}</p>
                                                 <!-- <p>Please activate your account.</p> -->
                                                 <p>{{ $t('account.common.AccountAuthenticationEmail.content.sure') }}</p>
                                                 <!-- <p>An activate mail has been sent to your email</p> -->
                                                 <p>{{ $t('account.common.AccountAuthenticationEmail.content.open') }}</p>
                                                 <p class="emailP"><img class="account_email_image" src="../../src/assets/img/account/Account_Email_image.png" alt=""><span class="email">{{email}}</span></p>
                                                 <!-- <p>Click on the link in the email to activate your account.</p> -->
                                                 <!-- <p>點擊信箱內的認證信件來開通您的帳戶！</p> -->
                                             </div>

                                                <!-- <div class="div_span_border"> -->
                                                <!-- <button :disabled="disabled" :class=" { red:changeRed == true } " class="normal" @click=' checkCreds '>check your mailbox</button> -->
                                                <!-- <button  :class=" { red:changeRed == true } " class="normal" @click=' checkCredsE '>开启信箱</button> -->
                                                 <!-- <span class="span_border"></span> -->
                                            <!-- </div> -->
                                        </form>

                                        <!-- <div style="width: 37em;margin:auto;"><p class="Join-NUWA-developer">Don’t  get  mail?</p></div> -->
                                        <div style="width: 37em;margin:auto;"><p class="Join-NUWA-developer">{{ $t('account.common.AccountAuthentication.content.noEmail') }}</p></div>
                                        <div class="div_signin">
                                            <!-- <button class="btn_signin" @click="bobo">Resend mail</button> -->
                                            <button class="btn_signin" @click="restSendEmail">{{ $t('account.common.AccountAuthentication.content.againEmail') }}</button>
                                        </div>

                                    </div>
                                    <LoginFooter/>
                                    <!-- <div class="div_footer">
                                        <p class="Copyright-2018-Nuw"><a class="copyright_a">Copyright © 2018 Nuwa Robotic. All rights reserved. </a></p>
                                        <p class="Login-Page_Link">
                                            <a>Terms of Use</a>
                                            <a>Pricacy Policy</a>
                                            <a>System Status</a>
                                        </p>
                                    </div> -->
                                    </div>
                                </div>

                                <br/>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
// import api from '../api'
// import config from '../config'
import LoginFooter from '@/views/LoginFooter.vue'
export default {
    name: 'Login',
    components: {
        LoginFooter
    },
    data (router) {
        return {
            loading: '',
            email: '',
            password: '',
            response: '',
            spacing: '',
            input_border: 'input_border',
            checkbox_flag: false,
            changeRed: false,
            focus_flag: false,
            disabled: true,
            src: require('../../src/assets/img/account/Account_1.gif'),
            border_style: '',
            creat_account_flag: false,
            error_response_flag: false
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
        // if (localStorage.remember_checkbox === 'true') {
        //     this.password = localStorage.login_password
        //     this.email = localStorage.login_email
        //     this.checkbox_flag = localStorage.remember_checkbox
        //     this.src = require('../../static/img/account/Account.gif')
        //     this.border_style = 'border:none;'
        // } else {
        //     this.password = ''
        //     this.email = ''
        // }
        this.email = localStorage.registerEmail
    },
    methods: {
        checkCredsE () {
            this.$router.push({ path: '/user/account/letterCompleted' })
        },
        btn_forget_password () {
            this.$router.push({ name: 'forgetPassword' })
        },
        restSendEmail () {
            const path = '/developer/request/resend/register'
            let body = { email: this.email }
            this._api.request('post', path, body)
                .then(response => {
                    if (response.status === 200) {
                        this.response = '重新寄送成功'
                    }
                })
                .catch(error => {
                    if (error) this.response = '重新寄送失败'
                })
        },
        reds () {
            this.changeRed = true
        },
        toggleLoading () {
            this.loading = (this.loading === '') ? 'loading' : ''
        },
        resetResponse () {
            this.response = ''
        },
        inputfocus () {
            this.resetResponse()
            this.focus_flag = true
        },
        remenber_me_btn (flag) {
            this.checkbox_flag = !this.checkbox_flag
            if (this.checkbox_flag) {
                this.src = require('../../src/assets/img/account/Account.gif')
                this.border_style = 'border:none;'
            } else {
                this.src = require('../../src/assets/img/account/Account_1.gif')
                this.border_style = ''
            }
        },
        register_page () {
            this.$router.push({ name: 'userRegister' })
        }
    },
    // 使用生命周期函数 实现input框样式
    beforeUpdate () {
        // 这是在判断 是否加密码的字间距
        if (this.password === '' || this.password === undefined) {
            this.spacing = ''
        } else {
            this.spacing = 'letter-spacing: .8em'
        }
        // 这是在判断 是否改变登陆按钮的颜色 是否禁用登陆按钮
        if (this.response) {
            this.changeRed = false
            this.disabled = true
            this.creat_account_flag = true
            this.error_response_flag = true
        } else if (this.password === '' || this.email === '') {
            this.changeRed = false
            this.disabled = true
        } else {
            this.changeRed = true
            this.disabled = false
            this.error_response_flag = false
        }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
    }
}
</script>

<style scoped>
    .email {
        width: 428px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #00b5e2;
    }
    .emailP{
        margin-top: 22px!important;
        display: flex;
    }
    .account_email_image{
        width: 22px;
        height: 20px;
        margin-left: 4px;
        margin-right: 9px;
    }
    .Youre-almost-ready {
        width: 428px;
        height: 120px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
        margin-left: 74px;
        text-align: left;
        padding-top: 16px;
        margin-top: 14px;
    }
    .Youre-almost-ready p{
        margin: 0;
    }
    .Youre-almost-ready p:nth-child(1){
        margin-bottom:2px;
    }
    .Youre-almost-ready p:nth-child(2){
        margin-bottom:2px;
    }
     .Youre-almost-ready a{
        text-align: left;
        margin-top: 22px;
        display: inline-block;
        color: #00b5e2;
    }
    .div_span_border{
        position: relative;
        margin-top: 34px;
    }
    .span_border{
        width: 280px;
        height: 0.1px;
        border: solid 1.2px rgba(51, 51, 51, 0.3);
        position: absolute;
        left: 105px;
        bottom: -1px;
    }
    .normal {
        width: 306px;
        height: 50px;
        border-radius: 10px;
        background-color: #00b5e2;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #ffffff;
        outline: none;
        border: none;
        cursor: pointer;
    }
    .mail-02_image{
        width: 100%;
        height: 100%;
    }
    .mail-02 {
        width: 169px;
        height: 169px;
        margin: auto;
    }
    .Remember_me_image{
        width: 100%;
        height: 100%;
    }
    .div_creat_account{
        width: 30.7em;
        height: 5.57em;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.3);
        border: solid 2.5px rgba(0, 181, 226, 0.5);
        margin: auto;
        margin-top: 13.5em;
        margin-bottom: -20.6em;
        cursor: pointer;
    }
    .span_creat_account{
        width: 21.4em;
        height: 2.35em;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #00b5e2;
        line-height: 3em;
    }
    .error_response_p{
        margin:0;
    }
    .input_error_response{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(246, 70, 53, 0.5);
        margin-top: -.6em;
        padding-bottom: 0.9em;
    }
    .label_class{
          width: 1.7em;
          height: 1.8em;
          border: 1px solid #00b5e2;
          border-radius: 2px;
          margin-top: -.3em;
          cursor: pointer;
    }
    .red{
         background-color: #00b5e2!important;
         opacity: 1!important;
        }
    .btn_signin{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 2px solid #00b5e2;
        background: white;
        color:#00b5e2;
        font-size: 22px;
        cursor: pointer;
        border-radius: 10px;
        letter-spacing: 1.2px;
        font-weight: bold;
    }
    .btn_login{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 0;
        border-radius: 10px;
        font-size: 22px;
        letter-spacing: 1.2px;
        font-weight: bold;
        cursor: pointer!important;
        background-color: rgba(51, 51, 51, 0.2);
        color: #ffffff;
        opacity: 0.5;
        margin-bottom: 0;
    }
    .loading{
        font-size:18px;
    }
    .btnStyle{
        background: #00b5e2;
        color: #ffffff;
    }
    .input_border{
        border-color: #f64635!important;
        color: #f64635!important;
    }
    html, body, .container-table {
        height: 100%;
        background-color: white !important;
    }
    .container-table {
        display: table;
        color: white;
        width:72%;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .loginForm .input-group {
        padding-bottom: 1em;
        height: 0;
    }
    .input-group input {
        height: 2.7em;
    }
    #userLoginSubmitButton {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        height: 100%;
        outline: none;
    }
    /* [fu] */

    /* 取消边框 */
    .box.box-solid.box-info{
        border:none;
    }
    .vertical-10p{
       padding-top: 3.5em!important;
    }
    .center-block1 {
       padding-bottom: 3.5em!important;
       margin-top: 50px;
    }
    .box-body{
        padding-top: 0;
    }
    /* input */
    .input-group input{
        width: 23.8em!important;
        border-radius: 12px!important;
        border: 1px solid rgba(51,51,51,0.5);
        color: #333333;
    }
    .input-group{
        margin: auto;
        font-weight: bold;
    }
    /* form剧中 */
    .col-sm-offset-4{
         margin: auto;
         width: 100%;
    }
    .checkbox_div{
        display: flex;
        margin-left: 2em;
        margin-bottom: 3.5em;
        width: 23.8em;
        margin: auto;
        padding-bottom: 2.8em;
        margin-top: .3em;
        position: relative;
    }
    /* 这是button */
    .btn-info{
       background-color: rgba(51,51,51,0.2);
        border: none;
        width: 10em!important;
        margin-left: 33%;
        border-radius: 8px!important;
        font-size: 22px!important;
        height: 50px!important;
        margin-bottom: 1.5em!important;
        margin:auto;
    }
    .div_signin{
        width: 37em;
        padding-top:2.4em;
        margin: auto;
    }

    /* input的字体大小 */
    .form-control{
        padding: 6px 24px;
        font-size: 18px;
    }
    .Forget_password{
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Remember_me{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0.8px;
        color: #333333;
        padding-left: 10px;
    }
    .Remember_me{
        cursor: pointer;
    }
    .checkbox_class{
        cursor: pointer;
    }
    .Forget_password{
        cursor: pointer;
    }
    /* 加form的上下border */
    .ui{
        width: 37em;
        border-bottom: 2px solid rgba(0,224,218,0.3);
        border-top: 2px solid rgba(51, 51, 51, 0.1);
        padding-top: 2.7em;
        padding-top: 2.4em;
        padding-bottom: 2.8em;
        }
    .box{
        box-shadow: none;
        margin-bottom: 0;
    }
    .box-body{
        padding-bottom: 0;
    }
    .Join-NUWA-developer{
        width: 164px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(51, 51, 51, 0.5);
        /* text-align: center; */
        margin: auto;
        padding-top: 2.7em;
    }

    /* 底部 */
    .Copyright-2018-Nuw{
        width: 400px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        margin-left: 1em;
        color: #333333;
    }
    .copyright_a{
        color: #333333;
    }
    .Login-Page_Link{
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Login-Page_Link a{
        padding: 0 18px;
        color: #333333;
    }
    .Login-Page_Link a:not(:last-child){
        border-right: 1px solid;
    }
    .input_form{
        width: 380px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        color: rgba(51, 51, 51, 0.3);
    }
    .div_footer{
        display:flex;
        clear:both;
        margin:auto;
        padding-top: 11em;
        width: 57em;
    }
    #app{
        background: rgba(0, 181, 226, 0.1);
    }

    /* [新增] */
    .container {
        margin: auto;
    }
    .label_class{
        width: 21.8px;
        height: 23.2px;
    }
    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }
    .btn_signin{
        display: block;
        margin: auto;
    }
    .Join-NUWA-developer{
        text-align: center;
    }
    .input-group input{
        outline: none;
        height: 1.7em!important;
        width: 20.2em!important
    }
    .checkbox_div{
        width: 20.2em!important;
    }
    /* 新增 */
</style>
